import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Detect Short Pay From Remittance Step
 *
 * After invoice references have been resolved and `auto_matched`
 * remittance line items materialized, walk those line items and open
 * a `short_pay` collection thread for any whose stated amount falls
 * short of the matched invoice's outstanding balance by the
 * org-configured threshold.
 *
 * Fires before any payment_application is materialized — this is the
 * earliest signal a collector can act on. The post-application detection
 * path stays in place; the partial unique index on the threads table
 * ensures the two paths never produce duplicate open threads.
 */
export const detectShortPayFromRemittanceStep = defineStepConfig({
  type: "detect_short_pay_from_remittance",
  name: "Detect Short Pay From Remittance",
  description:
    "Open short_pay collection threads for auto_matched remittance line items whose stated amount falls short of the invoice balance",
  category: "Data Access",
  libraryModule: "AccountsReceivable",
  inputSchema: z.object({
    remittanceAdviceId: z
      .uuid()
      .describe(
        "Remittance advice whose auto_matched line items will be checked for short pays",
      ),
  }),
  outputSchema: z.object({
    created: z.int().nonnegative(),
    skipped: z.int().nonnegative(),
    failed: z.int().nonnegative(),
  }),
  configSchema: z.object({}),
  emits: [] as const,
});
